// The promotion has five milestones; URL values must never control allocations.
export function parseOfferProgress(value: unknown): number {
  if (typeof value !== 'number' && typeof value !== 'string') return 0;
  if (typeof value === 'string' && !/^\d{1,2}$/.test(value)) return 0;
  const count = Number(value);
  return Number.isSafeInteger(count) && count >= 0 ? Math.min(count, 5) : 0;
}
